import { render } from "./_BaseHotspot.vue?vue&type=template&id=94c68b44&scoped=true&ts=true"
import script from "./_BaseHotspot.vue?vue&type=script&lang=ts"
export * from "./_BaseHotspot.vue?vue&type=script&lang=ts"

import "./_BaseHotspot.vue?vue&type=style&index=0&id=94c68b44&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c68b44"]])

export default __exports__